import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from '../../themes';
import { OldLogo } from './OldLogo';
import { NewLogo } from './NewLogo';
export const Logo = (props) => {
    const { name: themeName, palette } = useTheme();
    const logoProps = useMemo(() => {
        // this color seems to be unique to the text in the new
        // and not currently used elsewhere in the theme. Leaving it here
        // for now, but we should probably add it to the theme if we ever
        // need it elsewhere.
        const logoLiquidityBlack = '#393939';
        const colors = {
            primary: {
                icon: palette.primary.light,
                text: themeName === 'liquidity' ? logoLiquidityBlack : palette.primary.dark,
            },
            black: {
                icon: themeName === 'liquidity' ? logoLiquidityBlack : palette.common.black,
                text: themeName === 'liquidity' ? logoLiquidityBlack : palette.common.black,
            },
            white: {
                icon: palette.common.white,
                text: palette.common.white,
            },
        };
        const { color = 'primary', height, width, className } = props;
        return {
            height,
            width,
            className,
            textColor: colors[color].text,
            iconColor: colors[color].icon,
        };
    }, [props, themeName, palette]);
    return themeName === 'c2fo' ? _jsx(OldLogo, Object.assign({}, logoProps), void 0) : _jsx(NewLogo, Object.assign({}, logoProps), void 0);
};
//# sourceMappingURL=Logo.js.map